<template>
  <div class="dashboard-right">
    <caseModal v-if="showModal" @close="showModal=false" @refreshCreate="fetch"></caseModal>
    <mu-row gutter>
      <mu-col desktop="40">
        <mu-card class="card-style">
          <div class="create-text pointer" @click="showModal=true">
            新建档案
          </div>
        </mu-card>
        <mu-card class="card-style" v-if="Object.keys(tempCaseList).length > 0">
          <mu-appbar class="bgClass">
            <mu-text-field icon="search" style="margin:5px 10px 0 10px;" :underlineShow="false"
            slot="left" v-model="search.keyword" hintText="请输入姓名/账号搜索档案"
            @change="fetch(1000,1)" />
          </mu-appbar>
          <mu-row class="text-title">
            <mu-col style="color:#333;">您可能关注的患者</mu-col>
            <router-link :to="{name:'caselist'}"><mu-col><a style="color:#999;">查看全部</a></mu-col></router-link>
          </mu-row>
          <div v-if="Object.keys(caseLists).length > 0" class="homecase-style">
            <mu-row v-for="(caseList,index) in caseLists" style="height:66px;">
              <mu-col width="70" tablet="70" desktop="70" @click.native="toCaseInfo(caseList.id)">
                <personal :info="caseList" :keys="index" :noclick="noclick"></personal>
              </mu-col>
              <mu-col width="30" tablet="30" desktop="30" style="height:66px;line-height:56px;">
                <trainScene :caseID="caseList.id" :caseTM="caseList.tm" :showFlag="1"></trainScene>
              </mu-col>
            </mu-row>
          </div>
          <div v-else>
            <mu-row style="height:66px;line-height:66px;display:flex;justify-content:center;">
              <mu-col>
                没有找到符合的内容。
              </mu-col>
            </mu-row>
          </div>
        </mu-card>
        <mu-card class="card-style">
          <mu-row class="push-title">
            <mu-col style="color:#333;">推荐测评</mu-col>
            <router-link :to="{name:'evaluation'}"><mu-col><a style="color:#999;">更多</a></mu-col></router-link>
          </mu-row>
          <div v-for="(item,index) in evalList" v-if="index<5" style="height:33px;margin-left:30px;">
            <div class="pointer" @click="showEvalDetail(item)">
              <span>{{ item.SCALENAME }}</span>
            </div>
          </div>
        </mu-card>
      </mu-col>
      <mu-col desktop="60">
        <mu-card class="card-style">
          <mu-row class="push-title">
            <mu-col style="color:#333;">推荐训练</mu-col>
            <router-link :to="{name:'train'}"><mu-col><a style="color:#999;">更多</a></mu-col></router-link>
          </mu-row>
          <div class="push-train-style">
            <div v-for="(item,index) in trainList" v-if="index<9" class="push-train-single">
              <div class="board pointer" @click="showTrainDetail(item)">
                <img :src="address+item.image" />
              </div>
              <div class="boardName">{{ item.name }}</div>
            </div>
          </div>
          <digTrainContentmodal :game="train" @close="showTrainModal=false" v-if="showTrainModal"></digTrainContentmodal>
        </mu-card>
      </mu-col>
    </mu-row>
    <evalContentmodal :fromHome="fromHome" :showDialog="showEvalModal" @close="showEvalModal=false"></evalContentmodal>
    <mu-dialog  width="360" :open="showSetOrg">
      <span style="font-weight:800;">为了提供更好的服务，请完善您以下信息:</span>
      <div>
        <div>
          <p>医院/机构名称(若无，请填写无)</p>
          <input class="home-set-org" v-model="set_org" maxlength="50" type="text"><span v-if="err_org" style="font-size:14px;margin-left:20px;color:#f44336;">医院/机构名称不能为空</span>
        </div>
        <div>
          <p>科室(若无，请填写无)</p>
          <input class="home-set-dept" v-model="set_dept" maxlength="50" type="text"><span v-if="err_dept" style="font-size:14px;margin-left:20px;color:#f44336;">科室名称不能为空</span>
        </div>
      </div>
      <mu-raised-button slot="actions" @click="submit" label='提交'  primary />
      <mu-raised-button slot="actions" @click="closeSimpleDialog" color="black" label="下次再说" />
    </mu-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import caseModal from '../doc/caseModal.vue'
import personal from '../../common/personal.vue'
import trainScene from '../../common/train/trainScene.vue'
import searchBar from '../../common/searchBar.vue'
import digTrainContentmodal from '../train/digTrainContentmodal.vue'
import evalContentmodal from '../evaluation/evalContentmodal.vue'

export default({
  data () {
    return {
      address: GLOBAL.cognition,
      showModal: false,
      showTrainModal: false,
      showEvalModal: false,
      gName: GLOBAL.NAME,
      noclick: false,
      search: {
        keyword: ''
      },
      tempCaseList: [],
      caseLists: [],
      trainList: [],
      evalList: [],
      train: '',
      parentData:{
        name:'wsd',
        age:23
      },
      flag:0,
      caseId: '', //病例id
      caseIdDoc:'',//临时测评
      scaleId: '',//量表id
      scaleAlias: '', //量表
      scaleAliasName: '', //量表别名
      startType:'',//判断是1.0或者2.0测评
      showSetOrg:false,
      set_org:"",
      set_dept:"",
      err_org:false,
      err_dept:false,
      fromHome:true,
      flag:0,
      pages:1,
      game:"",
    }
  },
  filters:{
    upCase:function(res){
      return res.toUpperCase();
    }
  },
  components:{
    caseModal,
    personal,
    trainScene,
    searchBar,
    digTrainContentmodal,
    evalContentmodal
  },
  mounted(){
    console.log(this.$route.query.from_login);
    this.getUserMe();
    this.fetch(5);
    this.getTrainList();
    this.getEvalList();
  },
  methods: {
    submit(){
      if(!this.set_org){
        this.err_org = true;
        this.err_dept = false;
        return;
      }else{
        this.err_org = false;
      }
      if(!this.set_dept){
        this.err_dept = true;
        this.err_org = false;
        return;
      }else{
        this.err_dept = false;
      }
      this.$http.post("/api/Users/setOrg",{
        org: this.set_org,
        dept:this.set_dept,
      },{emulateJSON: true})
      .then((res)=>{
        console.log(res);
        this.closeSimpleDialog();
      })
      .catch((err)=>{
        alert("提交失败，请刷新后重试");
      })
    },
    closeSimpleDialog(){
      this.showSetOrg = false;
    },
    fetch: function(limit,flag) {
      this.showModal = false;
      Vue.http({
        method: 'GET',
        url:'/api/Cases/getList',
        params: {
          'search': this.search,
          'page': {
            current: 1,
            limit: limit
          }
        }
      })
      .then((res) => {
        if(flag){
          this.caseLists = res.data.data;
        } else {
          this.caseLists = res.data.data;
          this.tempCaseList = res.data.data;
        }
      })
    },
    //App.vue中获取userMe要比这边慢一步，所以还是需要调一次userMe，在想解决方案
    getUserMe(){
      this.$http.get('/api/Users/me')
      .then((res)=>{
        if(res.data.is_set_org){
          console.log("不需要设置信息");
        }else{
          if(GLOBAL.login_count == 0){
            this.showSetOrg = true;
            GLOBAL.login_count = 1;
          }
        }
      })
    },
    getTrainList: function () {
      this.trainList = [];
      Vue.http({
        method: 'GET',
        url: '/api/Game/recommendGame'
      })
      .then((res) => {
        this.trainList = [];
        if(Object.keys(res.data.data).length>0){
          console.log(res.data);
          this.trainList = res.data.data;
        }
      })
    },
    showTrainDetail:function(item){
      this.showTrainModal=true;
      this.train = item;
    },
    getEvalList:function(type){
      Vue.http({
        method: 'GET',
        url: '/api/Evaluation/recommendScale',
        params: {}
      })
      .then((res) => {
        this.evalList = [];
        if(Object.keys(res.data.data).length>0){
          this.evalList = JSON.parse(JSON.stringify(res.data.data));
        }
      })
    },
    toCaseInfo (id) {
      this.$router.push({name: 'caseinfo', params: {id: id}});
    },
    showEvalDetail:function(item){
      console.log(item)
      this.game = item;
      this.showEvalModal=true;
      this.caseId= item.caseid;
      if(item.scalealias == 'wab'){
        this.startType=2;
      } else {
        this.startType=1;
      }
      this.scaleName = item.SCALENAME;
      this.scaleId = item.ID;
      this.scaleAlias = item.SCALEALIAS;
    }
  }
})
</script>
<style scoped>
  .dashboard-right{
    position: absolute;
    top: 80px;
    left: 230px;
    bottom: 30px;
    overflow-x: hidden!important;
    overflow-y: auto;
    margin: 0 25px;
  }
  .card-style{
    margin: 20px 15px 30px 15px;
  }
  .create-text{
    text-align: center;
    font-family: PingFangTC-Semibold;
    font-size: 16px;
    color: #0A81E5;
    height: 60px;
    line-height: 60px;
    font-weight: bold;
  }
  .bgClass{
 
  }
  .text-title{
    margin: 20px 30px;
    font-size:12px;
  }
  .push-title{
    padding: 20px 30px;
    font-size:14px;
  }
  .push-train-style{
    display: flex;
    flex-wrap: wrap;
  }
  .push-train-single{
    margin: 0 30px 10px 30px;
    width: 140px;
  }
  .board{
    width:140px;
    height:140px;
  }
  .board img{
    width:140px;
    height:140px;
  }
  .homecase-style{
    max-height: 330px;
    overflow: auto;
  }
  .home-set-org, .home-set-dept{
    border-radius: 0;
    border:1px solid #ddd;
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// homepage.vue?22b4b8ac